import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M6.445.25h7.07c1.602 0 3.008 1.016 3.555 2.54l1.367 3.905C19.337 7.085 20 7.985 20 9v7.5c0 .703-.586 1.25-1.25 1.25H17.5c-.703 0-1.25-.547-1.25-1.25v-1.875H3.75V16.5c0 .703-.586 1.25-1.25 1.25H1.25C.547 17.75 0 17.203 0 16.5V9a2.53 2.53 0 0 1 1.523-2.305L2.891 2.79C3.438 1.266 4.844.25 6.445.25M3.75 11.5c.664 0 1.25-.547 1.25-1.25C5 9.586 4.414 9 3.75 9c-.703 0-1.25.586-1.25 1.25 0 .703.547 1.25 1.25 1.25M16.25 9c-.703 0-1.25.586-1.25 1.25 0 .703.547 1.25 1.25 1.25.664 0 1.25-.547 1.25-1.25 0-.664-.586-1.25-1.25-1.25m-3.828-5.312a.72.72 0 0 0-.156-.782.594.594 0 0 0-.782 0l-5 3.75c-.234.157-.312.43-.234.703.078.235.352.391.625.391h2.11l-1.446 2.852a.72.72 0 0 0 .156.78c.235.157.547.196.782 0l5-3.75c.234-.155.312-.429.234-.702-.078-.235-.352-.43-.586-.43h-2.148z"
    }, null, -1)
  ])))
}
export default { render: render }